import { ReactElement } from "react";
import { alpha, Box, Popover, Tooltip, Typography } from "@mui/material";
import { NavLink as RouterLink, useLocation } from "react-router-dom";
import { getActive } from "src/components/nav-section";
import PermissionInfo from "src/components/permissions/permissionInfo";
import useLocales from "src/hooks/useLocales";
import { ListItem } from "./NavItem";
import { ListItemTextStyle } from "./style";

interface Props {
  anchorEl: HTMLElement | null;
  handlePopoverClose: () => void;
  submenu?: {
    path: string;
    title: string;
    disabled?: boolean;
    role?: Boolean;
    color?: string;
    caption?: string;
    locked?: boolean;
    moduleLocked?: boolean;
    module?: string;
    info?: ReactElement;
  }[];
  title: string;
  locked?: boolean;
  moduleLocked?: boolean;
  module?: string;
  handleOpenModuleDialog?: (module: string) => void;
}

const NavItemSubmenuPopover = ({
  anchorEl,
  handlePopoverClose,
  submenu,
  title,
  locked,
  moduleLocked,
  module,
  handleOpenModuleDialog,
}: Props) => {
  const { translate } = useLocales();
  const { pathname } = useLocation();

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: 60,
      }}
      onClose={handlePopoverClose}
      hideBackdrop
      //   sx={{
      //     pointerEvents: "none",
      //   }}
      PaperProps={{
        sx: {
          bgcolor: "background.paper",
          borderRadius: "8px",
          p: 1,
          display: "flex",
          flexDirection: "column",
          width: "200px",
          border: `1px solid ${alpha("#d0d7de", 0.5)}`,
        },
      }}
    >
      <Box>
        <Typography
          sx={{
            fontWeight: "bold",
            color: "text.greyLight",
            fontSize: "12px",
            mb: 1,
            ml: 1,
          }}
          variant="subtitle2"
        >
          {translate(title)}
        </Typography>
        {locked && <PermissionInfo moduleLocked={moduleLocked} />}
      </Box>
      {submenu
        ?.filter((m) => m.role)
        .map((menu, index) => {
          const active = getActive(menu.path, pathname);
          return (
            <ListItem
              key={menu.path || index}
              {...(!menu.locked
                ? {
                    component: RouterLink,
                    to: menu.path,
                  }
                : {})}
              disabled={menu.disabled}
              onClick={() => {
                if (menu.moduleLocked) {
                  handleOpenModuleDialog?.(menu.module ?? "");
                }
              }}
              sx={{
                "&:hover, &.activeRoot, &.active": {
                  bgcolor: "#f5f5f5",
                },
              }}
            >
              <ListItemTextStyle
                primary={translate(menu.title)}
                disableTypography
                sx={{
                  color: "text.greyLight",
                  fontWeight: active ? "bold" : "normal",
                  fontSize: "12px",
                }}
                secondary={
                  <Tooltip title={translate(menu.caption) || ""} arrow>
                    <Typography
                      noWrap
                      variant="caption"
                      component="div"
                      sx={{ textTransform: "initial", color: "text.greyLight" }}
                    >
                      {translate(menu.caption)}
                    </Typography>
                  </Tooltip>
                }
              />
              {menu.info && menu.info}
              {menu.locked && (
                <PermissionInfo moduleLocked={menu.moduleLocked} />
              )}
            </ListItem>
          );
        })}
    </Popover>
  );
};

export default NavItemSubmenuPopover;
